module.exports = __webpack_public_path__ + "img/brain.6329e1c8.png";